export default __webpack_public_path__ + "static/media/35_3_1.1355d967.png";